import { mergeProps } from "@base-ui/react/merge-props"
import { useRender } from "@base-ui/react/use-render"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "group/badge inline-flex h-5 w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-4xl border border-transparent px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest whitespace-nowrap transition-all focus-visible:border-ring focus-visible:ring-[0.1875rem] focus-visible:ring-ring/50 has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&>svg]:pointer-events-none [&>svg]:size-3!",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground [a]:hover:bg-primary/80 shadow-sm",
        secondary:
          "bg-secondary text-secondary-foreground [a]:hover:bg-secondary/80 shadow-sm",
        destructive:
          "bg-error/25 text-error border border-error/30 focus-visible:ring-error/20 dark:bg-error/30 dark:focus-visible:ring-error/40 [a]:hover:bg-error/30",
        outline:
          "border-border bg-foreground/5 text-foreground [a]:hover:bg-muted [a]:hover:text-muted-foreground",
        success:
          "bg-success/25 text-success border border-success/40",
        warning:
          "bg-warning/25 text-warning border border-warning/40",
        ghost:
          "hover:bg-muted hover:text-muted-foreground dark:hover:bg-muted/50",
        link: "text-primary underline-offset-4 hover:underline",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant = "default",
  render,
  ...props
}: useRender.ComponentProps<"span"> & VariantProps<typeof badgeVariants>) {
  return useRender({
    defaultTagName: "span",
    props: mergeProps<"span">(
      {
        className: cn(badgeVariants({ variant }), className),
      },
      props
    ),
    render,
    state: {
      slot: "badge",
      variant,
    },
  })
}

export { Badge, badgeVariants }

